import { getTermValue, resetTerms } from '../../../../JsonQuery';
import { TTagsManager } from '../../types/tag';
import { ESuburbanOfferFilter } from '../../../../api-models/common/json_query';
import { createTagValue } from '../../utils/createTagValue';

const ID = 'possessor' as const;

export const possessorTagManager: TTagsManager = {
  id: ID,
  extractTagsFromJsonQuery: ({ jsonQuery }) => {
    const possessor = getTermValue('suburban_offer_filter')(jsonQuery);

    if (possessor === null) {
      return null;
    }

    const label = possessor === ESuburbanOfferFilter.Builder ? 'От застройщика' : 'От собственников и агентов';

    return [{ label, value: createTagValue(ID) }];
  },
  modifyJsonQueryByRemovingTag: ({ jsonQuery }) => resetTerms(['suburban_offer_filter'])(jsonQuery),
};
